module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenSize > 1 && _vm.sidebarVisible),
      expression: "screenSize > 1 && sidebarVisible"
    }],
    staticClass: "sidebar",
    class: _vm.isDownloading ? 'sidebar-downloading' : ''
  }, [_c('div', {
    staticClass: "sidebar-calendar"
  }, [_c('calendar', {
    attrs: {
      "screenSize": _vm.screenSize,
      "current": _vm.current,
      "selectedDay": _vm.selectedDay
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sidebar-info"
  }, [_c('div', {
    staticClass: "sidebar-info-value"
  }, [_vm._v("\n                " + _vm._s(_vm.$l('main/titleSD'))), _c('span', {
    class: {
      red: _vm.isSizeBelowLimit
    }
  }, [_vm._v(" " + _vm._s(_vm.roundDecimal) + "% ")]), _vm._v(" (" + _vm._s(_vm.$l('settings/status/of')) + " 2 Gb)\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-status-value"
  }, [_vm._v("\n                " + _vm._s(_vm.$l('main/status')) + ": " + _vm._s(_vm.$l('main/' + _vm.statusSidebar)) + "\n            ")])])]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenSize < 2 && _vm.sidebarVisible),
      expression: "screenSize < 2 && sidebarVisible"
    }],
    staticClass: "sidebar-top-container"
  }, [_c('div', {
    staticClass: "sidebar-top"
  }, [_c('div', {
    staticClass: "sidebar-top-calendar"
  }, [_c('calendar', {
    attrs: {
      "small": true,
      "screenSize": _vm.screenSize,
      "current": _vm.current,
      "selectedDay": _vm.selectedDay
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sidebar-top-info"
  }, [_c('div', {
    staticClass: "sidebar-info-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.$l('main/titleSD'))), _c('span', {
    class: {
      red: _vm.isSizeBelowLimit
    }
  }, [_vm._v(" " + _vm._s(_vm.roundDecimal) + "% ")]), _vm._v(" (" + _vm._s(_vm.$l('settings/status/of')) + " 2 Gb)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-status-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.$l('main/status')) + ": " + _vm._s(_vm.$l('main/' + _vm.statusSidebar)) + "\n                    ")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7120a472","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarContainer.vue
// module id = 468
// module chunks = 1